var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"searchWords-wrap"}},[_c('tool',{ref:"tool",attrs:{"showLevel":_vm.showLevel}},[_c('template',{slot:"title"},[_vm._v("搜索下拉词推荐")])],2),_c('task',{ref:"task",attrs:{"code":_vm.code}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }